import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { App } from './App.tsx';
import './styles.css';

// Регистрируем service worker. SW в `sw.ts` делает `skipWaiting` +
// `clients.claim`, новая версия активируется при следующей перезагрузке
// страницы (или cold start PWA — на iPhone пользователь убивает приложение
// в app switcher и открывает заново). Раньше тут стоял setInterval
// каждые 60 сек с registration.update() — на iOS standalone это давало
// каскад: update() → новый SW activate → controllerchange → reload →
// update() → ... и пользователь видел белый экран от бесконечной
// перезагрузки. Без поллинга PWA стабильна, обновление приходит на
// следующем cold-start'е.
registerSW({ immediate: true });

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
